import { ReactNode, useState } from 'react'
import { Flex, Text } from '@radix-ui/themes'
import { EyeOpenIcon, EyeClosedIcon } from '@radix-ui/react-icons'
import { formatValue, formatIsoDateMMDDYYYY } from './claim-form-utils'
import { FieldRow } from './claim-form-fields'
import { CLAIMANT_ROWS } from './claim-form-constants'
import { getFieldLabel } from './claim-form-schema-utils'

function maskSSN(ssn: string): string {
  if (ssn.length <= 4) {
    return ssn
  }
  return '***-**-' + ssn.slice(-4)
}

function SSNField({ value }: { value: string | null }) {
  const [visible, setVisible] = useState(false)

  if (!value) {
    return null
  }

  return (
    <Flex direction="column" gap="1" className="claim-form-field">
      <Text size="1" color="gray">
        SSN
      </Text>
      <Flex align="center" gap="2">
        <Text size="2">{visible ? value : maskSSN(value)}</Text>
        <button
          className="claim-form-ssn-toggle"
          onClick={() => setVisible((prev) => !prev)}
          aria-label={visible ? 'Hide SSN' : 'Show SSN'}>
          {visible ? <EyeOpenIcon /> : <EyeClosedIcon />}
        </button>
      </Flex>
    </Flex>
  )
}

function renderCell(field: string, data: Record<string, unknown>) {
  if (field === 'socialSecurityNumber') {
    return <SSNField value={formatValue(data[field])} />
  }
  if (field === 'dateOfBirth') {
    return <FieldRow label={getFieldLabel(field)} value={formatIsoDateMMDDYYYY(data[field])} />
  }
  return <FieldRow label={getFieldLabel(field)} value={formatValue(data[field])} />
}

export function ClaimantFields({ data }: { data: Record<string, unknown> }) {
  const showExplanation = data.originalClaimant === false && !!data.notOriginalPurchaserExplanation

  return (
    <Flex direction="column" gap="3">
      {CLAIMANT_ROWS.map(([left, right]) => {
        let rightCell: ReactNode
        if (left === 'originalClaimant' && showExplanation) {
          rightCell = (
            <FieldRow
              label="If not, explain"
              value={formatValue(data.notOriginalPurchaserExplanation)}
            />
          )
        } else if (right) {
          rightCell = renderCell(right, data)
        } else {
          rightCell = <div />
        }
        return (
          <div key={left} className="claim-form-two-col">
            {renderCell(left, data)}
            {rightCell}
          </div>
        )
      })}
    </Flex>
  )
}
